import { IDataGridColumnValidatorResult } from './DataGridColumn.class';

export class DataGridOptions {
    isRowEditableFunc: (item: any) => boolean;
    isRowSelectableFunc: (item: any) => boolean;
    shownItemsFilterFunc: (item: any) => boolean;
    rowValidator?: (
        itemIndex: any,
        items: any[]
    ) => IDataGridColumnValidatorResult[];
    tableMinWidthCSS?: string;
    uniqueValueKey?: string;
    additionalItemValidators: ((item: any) => any)[];

    constructor() {
        this.isRowEditableFunc = () => true;
        this.isRowSelectableFunc = () => true;
        this.shownItemsFilterFunc = () => true;
        this.tableMinWidthCSS = 'unset';
        this.rowValidator = undefined;
        this.uniqueValueKey = undefined;
        this.additionalItemValidators = [];
    }
}
